<template>
    <div class="main">
        <global-tag>
            <span slot="title">社戒社康人员</span>
            <div class="search" slot="search">
                <el-form label-width="120px" :model="queryInfo">
                    <div class="searchBox">
                        <div class="content">
                            <el-row>
                                <el-col :span="5">
                                    <el-form-item label="姓名：">
                                        <el-input
                                            clearable
                                            v-model.trim="queryInfo.personName"
                                            style="width: 100%"
                                            placeholder="请输入"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="btn">
                            <el-button type="primary" @click="querySearch" class="searchBtns"
                                >查询</el-button
                            >
                        </div>
                    </div>
                </el-form>
            </div>
        </global-tag>
        <div class="table_title">
            <div class="btn_group">
                <el-button
                    type="success"
                     icon="el-icon-plus"
            class="openBtns"
                    size="medium"
                    @click="addServices('新增', 'add')"
                    >新增</el-button
                >
                <el-button
                    type="primary"
                    icon="el-icon-download" class="button downOutBtns"
                    size="medium"
                    @click="createExcel"
                    >导出数据</el-button
                >
                <div style="display: none">
                    <input @change="fileChange" id="speechUpload" type="file" />
                </div>
               <label for="speechUpload" class="labelImportBtn inDwonBtns">
         
          <span> <i class="el-icon-upload2"></i>导入数据</span>
        </label>
                <el-button
                    type="warning"
                   icon="el-icon-sold-out" class="button modelDownds"
                    size="medium"
                    @click="downExcel"
                    >下载模板</el-button
                >
            </div>
            <!-- 筛选按钮 -->
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                         class="dropRests"
                        @click="reset"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                        <el-dropdown trigger="click" :hide-on-click="false"  class="dropdown1">
                            <span class="el-dropdown-link">
                                <i
                                    class="el-icon-s-grid el-icon--right"
                                    style="color: #fff"
                                ></i>
                                <i
                                    class="el-icon-arrow-down el-icon--right"
                                ></i>
                            </span>
                            <el-dropdown-menu
                                slot="dropdown"
                                class="table_checkbox"
                            >
                                <el-dropdown-item>
                                    <el-checkbox-group
                                        v-model="tableChekbox"
                                        @change="tableChekboxChange"
                                    >
                                        <el-checkbox label="序号"></el-checkbox
                                        ><br />
                                        <el-checkbox label="姓名"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="身份证号"
                                        ></el-checkbox
                                        ><br />

                                        <el-checkbox
                                            label="联系电话"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="户籍地址"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="户籍人口"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="人员类型"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="人口类型"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="性别"></el-checkbox
                                        ><br />
                                        <el-checkbox label="民族"></el-checkbox
                                        ><br />
                                        <el-checkbox label="学历"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="政治面貌"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="婚姻状况"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="与房主关系"
                                        ></el-checkbox
                                        ><br />

                                        <el-checkbox
                                            label="吸毒原因"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="毒品来源"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="有无犯罪史"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="查获日期"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="经济来源"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="戒毒执行单位"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="开始日期"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="结束日期"
                                        ></el-checkbox
                                        ><br />

                                        <el-checkbox label="备注"></el-checkbox
                                        ><br />

                                        <el-checkbox
                                            label="标准地址"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="点位坐标"
                                        ></el-checkbox
                                        ><br />

                                        <el-checkbox
                                            label="创建时间"
                                        ></el-checkbox
                                        ><br />

                                        <el-checkbox
                                            label="最后编辑时间"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="创建人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="最后编辑人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="操作"></el-checkbox
                                        ><br />
                                    </el-checkbox-group>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="550px"
                :header-cell-style="{
                    background: '#e6e6e6',
                    color: '#000',
                }"
                border
            >
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="姓名"
                    align="center"
                    prop="personName"
                    width="120"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '姓名'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="身份证号"
                    align="center"
                    prop="idCard"
                    width="160"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '身份证号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="联系电话"
                    align="center"
                    prop="phone"
                    width="130"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '联系电话'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="户籍地址"
                    align="center"
                    prop="originPlace"
                    width="160"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '户籍地址'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="户籍人口"
                    align="center"
                    width="140"
                    prop="origin"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '户籍人口'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="人员类型"
                    align="center"
                    width="100"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '人员类型'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.personnelType == 0"
                            >常住人口</span
                        >
                        <span v-if="scope.row.personnelType == 1">出租</span>
                        <span v-if="scope.row.personnelType == 2">流动</span>
                        <span v-if="scope.row.personnelType == 3">空房</span>
                        <span v-if="scope.row.personnelType == 4">境外</span>
                        <span v-if="scope.row.personnelType == 5">未落户</span>
                        <span v-if="scope.row.personnelType == 6">商住房</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="人口类型"
                    align="center"
                    prop="populationType"
                    width="120"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '人口类型'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.populationType == 1"
                            >本地户籍人口</span
                        >
                        <span v-if="scope.row.populationType == 2"
                            >外地户籍人口</span
                        >
                        <span v-if="scope.row.populationType == 3">其他</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="性别"
                    align="center"
                    width="80"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '性别'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.sex == 1">男</span>
                        <span v-if="scope.row.sex == 2">女</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="民族"
                    align="center"
                    prop="nation"
                    width="120"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '民族'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="学历"
                    align="center"
                    width="120"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '学历'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.education == 1">小学</span>
                        <span v-if="scope.row.education == 2">初中</span>
                        <span v-if="scope.row.education == 3">高中</span>
                        <span v-if="scope.row.education == 4">职校</span>
                        <span v-if="scope.row.education == 5">专科</span>
                        <span v-if="scope.row.education == 6">本科</span>
                        <span v-if="scope.row.education == 7">硕士</span>
                        <span v-if="scope.row.education == 8">博士</span>
                        <span v-if="scope.row.education == 9">其他</span>
                    </template>
                </el-table-column>

                <el-table-column
                    label="政治面貌"
                    align="center"
                    width="100"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '政治面貌'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.partyType == 0">中共党员</span>
                        <span v-if="scope.row.partyType == 1">共青团员</span>
                        <span v-if="scope.row.partyType == 2">群众</span>
                        <span v-if="scope.row.partyType == 3">其他</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="婚姻状况"
                    align="center"
                    width="90"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '婚姻状况'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.maritalStatus == 1">未婚</span>
                        <span v-if="scope.row.maritalStatus == 2">已婚</span>
                        <span v-if="scope.row.maritalStatus == 3">离婚</span>
                        <span v-if="scope.row.maritalStatus == 4">丧偶</span>
                        <span v-if="scope.row.maritalStatus == 5">再婚</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="与房主关系"
                    align="center"
                    width="140"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '与房主关系'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.relationship == 1">本人</span>
                        <span v-if="scope.row.relationship == 2">夫妻</span>
                        <span v-if="scope.row.relationship == 3">父亲</span>
                        <span v-if="scope.row.relationship == 4">母亲</span>
                        <span v-if="scope.row.relationship == 5">岳父</span>
                        <span v-if="scope.row.relationship == 6">岳母</span>
                        <span v-if="scope.row.relationship == 7">长子</span>
                        <span v-if="scope.row.relationship == 8">次子</span>
                        <span v-if="scope.row.relationship == 9">长女</span>
                        <span v-if="scope.row.relationship == 10">次女</span>
                        <span v-if="scope.row.relationship == 11">其他</span>
                        <span v-if="scope.row.relationship == 12">儿媳</span>
                        <span v-if="scope.row.relationship == 13">孙子</span>
                        <span v-if="scope.row.relationship == 14">孙女</span>
                        <span v-if="scope.row.relationship == 15">女婿</span>
                        <span v-if="scope.row.relationship == 16">租户</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="吸毒原因"
                    align="center"
                    width="140"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '吸毒原因'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.drugsCause == 1">亲友影响</span>
                        <span v-if="scope.row.drugsCause == 2">医药依赖</span>
                        <span v-if="scope.row.drugsCause == 3">他人欺骗</span>
                        <span v-if="scope.row.drugsCause == 4">思想空虚</span>
                        <span v-if="scope.row.drugsCause == 5">寻求刺激</span>
                        <span v-if="scope.row.drugsCause == 6">好奇心驱使</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="毒品来源"
                    align="center"
                    width="120"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '毒品来源'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.drugSources == 1">黑市购买</span>
                        <span v-if="scope.row.drugSources == 2">他人提供</span>
                        <span v-if="scope.row.drugSources == 3">偷盗</span>
                        <span v-if="scope.row.drugSources == 4">药店</span>
                        <span v-if="scope.row.drugSources == 5">自制</span>
                        <span v-if="scope.row.drugSources == 6">其他</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="有无犯罪史"
                    align="center"
                    prop="criminalHistoryFlag"
                    width="130"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '有无犯罪史'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.criminalHistoryFlag == 1"
                            >是</span
                        >
                        <span v-if="scope.row.criminalHistoryFlag == 0"
                            >否</span
                        >
                    </template>
                </el-table-column>
                <el-table-column
                    label="查获日期"
                    align="center"
                    prop="seizedDate"
                    width="130"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '查获日期'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="经济来源"
                    align="center"
                    width="150"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '经济来源'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.pocketBook == 0">无生活来源</span>
                        <span v-if="scope.row.pocketBook == 1">政府补贴</span>
                        <span v-if="scope.row.pocketBook == 2">工作</span>
                        <span v-if="scope.row.pocketBook == 3">子女补贴</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="戒毒执行单位"
                    align="center"
                    prop="gamblingUnit"
                    width="130"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '戒毒执行单位'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="开始日期"
                    align="center"
                    prop="startTime"
                    width="120"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '开始日期'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="结束日期"
                    align="center"
                    width="120"
                    prop="endTime"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '结束日期'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    label="备注"
                    align="center"
                    prop="remark"
                    width="200"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '备注'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="标准地址"
                    align="center"
                    prop="address"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '标准地址'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="点位坐标"
                    align="center"
                    width="200"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '点位坐标'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span>
                            经度：{{ scope.row.longitude }}纬度：{{
                                scope.row.latitude
                            }}</span
                        >
                    </template>
                </el-table-column>

                <el-table-column
                    label="创建时间"
                    align="center"
                    width="200"
                    prop="createDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="最后编辑时间"
                    align="center"
                    prop="updateDate"
                    width="200"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '最后编辑时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="创建人"
                    align="center"
                    width="200"
                    prop="createPersonName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="最后编辑人"
                    align="center"
                    width="200"
                    prop="updatePersonName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '最后编辑人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    width="240px"
                    fixed="right"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div>
                            <span
                                @click="addServices('编辑', scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >编辑</span
                            >
                            <span
                                @click="deleteItem(scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >删除</span
                            >
                            <span
                                @click="seeMap(scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >查看地图定位</span
                            >
                            <!-- <span
                                @click="goSee(scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >走访处理</span
                            > -->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                :page-size="pageOne.pageSize"
                :current-page.sync="pageOne.pageNo"
                layout="total, sizes, prev, pager, next, jumper"
                :total="pageOne.total"
                @size-change="handletableDataSize"
                @current-change="handleTableDataChange"
            ></el-pagination>
        </div>
        <add-service
            v-if="serviceState"
            :openData="serviceInfo"
            @cancleService="cancleService"
        ></add-service>
        <map-info
            v-if="mapState"
            :openData="mapInfo"
            @cancleService="cancleService"
        ></map-info>
    </div>
</template>
<script>
import globalTag from "../../../../components/globalTag"
import addService from "./components/addService"
import mapInfo from "@/components/mapInfo"
import signList from "./components/signList"

export default {
    name: "serviceMange",
    inject: ["reload"], //注入
    components: { globalTag, addService, signList, mapInfo },
    data() {
        return {
            mapState: false,
            mapInfo: {},
            signState: false,
            signInfo: {},
            sexOptions: [
                { value: "0", label: "男" },
                { value: "1", label: "女" },
            ],
            pageOne: { total: 0, pageSize: 10, pageNo: 1 },
            tableData: [],
            queryInfo: { personName: "" },
            serviceState: false,
            serviceInfo: {},

            tempTableChekbox: [
                "序号",
                "姓名",
                "身份证号",
                "联系电话",
                "户籍地址",
                "户籍人员",
                "人员类型",
                "人口类型",
                "性别",
                "民族",
                "学历",
                "政治面貌",
                "婚姻状况",
                "与房主关系",
                "吸毒原因",
                "毒品来源",
                "有无犯罪史",
                "查获日期",
                "经济来源",
                "戒毒执行单位",
                "开始日期",
                "结束日期",
                "备注",
                "标准地址",
                "点位坐标",

                "创建时间",
                "最后编辑时间",
                "创建人",
                "最后编辑人",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "姓名",
                "身份证号",
                "联系电话",
                "户籍地址",
                "户籍人员",
                "人员类型",
                "人口类型",
                "性别",
                "民族",
                "学历",
                "政治面貌",
                "婚姻状况",
                "与房主关系",
                "吸毒原因",
                "毒品来源",
                "有无犯罪史",
                "查获日期",
                "经济来源",
                "戒毒执行单位",
                "开始日期",
                "结束日期",
                "备注",
                "标准地址",
                "点位坐标",

                "创建时间",
                "最后编辑时间",
                "创建人",
                "最后编辑人",
                "操作",
            ],
        }
    },
    created() {
        this.getList()
    },
    methods: {
        //删除表格信息
        deleteItem(date) {
            let params = {
                id: date.id,
            }
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url: "/ypt/admin/quitkangPeople/info/deleteById",
                        method: "POST",
                        data: params,
                    })
                    .then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message)
                            // this.tableData = [];
                            this.getList()
                        } else {
                            this.$message.error(res.message)
                        }
                    })
            })
        },
        //活动时间发生变化
        recTimeChange(val) {
            if (!val) return
            this.formData.beginTime = val[0]
            this.formData.endTime = val[1]
        },
        // 查看定位
        seeMap(row) {
            this.mapState = true
            this.mapInfo = {
                address: row.address,
                longitude: row.longitude,
                latitude: row.latitude,
                provinceId: row.provinceId,
                cityId: row.cityId,
                zoneId: row.zoneId,
                streetId: row.streetId,
                shequId: row.shequId,
                id: row.id,
                state: true,
            }
        },
        // 走访处理
        goSee(row) {
            this.signState = true
            this.signInfo = { id: row.id, state: true }
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.getList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.getList()
        },
        // 获取数据
        getList() {
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
                personName: this.queryInfo.personName,
            }
            this.$http
                .request({
                    url: "/ypt/admin/quitkangPeople/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.pageOne.total = 0
                            return
                        }
                        if (res.content.list.length > 0) {
                            res.content.list.forEach((item) => {
                                item.hasChagned =
                                    Number(item.counts) - Number(item.stock)
                            })
                        }
                        this.tableData = res.content.list
                        this.pageOne.total = res.content.count
                    }
                })
        },

        // 选择列的展示方式
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        // 取消新增、编辑、查看
        cancleService(state) {
            this.serviceState = false
            this.mapState = false
            this.signState = false
            if (state == true) {
                this.getList()
            }
        },

        // 新增\编辑\查看
        addServices(title, row) {
            this.serviceState = true

            this.serviceInfo = {}
            this.serviceInfo = {
                title: title,
                id: title == "新增" ? "" : row.id,
                state: true,
            }
        },

        // 页面刷新
        reset() {
            this.reload()
        },
        // 搜索
        querySearch() {
            this.getList()
        },
        // 下载模板
        async downExcel() {
            const res = await this.request2({
                url: "/ypt/admin/quitkangPeople/info/downloadExcel",
                method: "POST",
                data: {
                    postName: "*",
                },
                responseType: "blob",
            })
            const blob = new Blob([res], { type: "application/vnd.ms-excel" })
            const fileName = "社戒社康人员.xls"
            const linkNode = document.createElement("a")

            linkNode.download = fileName //a标签的download属性规定下载文件的名称
            linkNode.style.display = "none"
            linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
            document.body.appendChild(linkNode)
            linkNode.click() //模拟在按钮上的一次鼠标单击

            URL.revokeObjectURL(linkNode.href) // 释放URL 对象
            document.body.removeChild(linkNode)
        },
        //导出excel
        async createExcel() {
            const res = await this.request2({
                url: "/ypt/admin/quitkangPeople/info/downloadExcel",
                method: "POST",
                data: {},
                responseType: "blob",
            })
            const blob = new Blob([res], { type: "application/vnd.ms-excel" })
            const fileName = "社戒社康人员.xls"
            const linkNode = document.createElement("a")

            linkNode.download = fileName //a标签的download属性规定下载文件的名称
            linkNode.style.display = "none"
            linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
            document.body.appendChild(linkNode)
            linkNode.click() //模拟在按钮上的一次鼠标单击

            URL.revokeObjectURL(linkNode.href) // 释放URL 对象
            document.body.removeChild(linkNode)
        },
        // 导入
        async fileChange(event) {
            console.log(event)
            const file = event.target.files[0]
            console.log(file)
            const personType = "1"
            let config = {
                headers: { "Content-Type": "multipart/form-data" },
            }
            let formData = new FormData()
            formData.append("personType", personType)
            console.log(formData)
            formData.append("file", file)
            let result = await this.$http.post(
                "/ypt/admin/quitkangPeople/info/excel",
                formData,
                config
            )
            // 清空文件
            const fileEle = document.getElementById("speechUpload")
            fileEle.value = ""
            if (result.code == 200) {
                this.$message.success(result.message)
                this.getList()
            } else {
                this.$message.warning(result.message)
            }
        },
    },
}
</script>
<style lang="less" scoped>
.searchBox {
    display: flex;
    .content {
        flex: 1;
    }
}
/deep/.table_title {
    margin-top: 15px !important;
}
/deep/.btn_group {
    margin-top: 0px !important;
}
.button {
    margin-bottom: 4px;
}
.labelImportBtn,
.domModel {
    background: orange;
    border-radius: 3px;
    cursor: pointer;
    margin: 0 10px;
    font-size: 12px;
    padding: 4px 17px;
    color: #fff;
    line-height: 28px;
    display: inline-block;
}
.domModel {
    background: green;
    text-decoration: none;
}
.operBtn {
    cursor: pointer;
    margin-left: 10px;
}
</style>